<td class="ikon">
  <dokument-format-ikon [mimeinfo]="opplasting().mimeinfo"/>
</td>
<td class="navn" data-testid="filnavn">{{ opplasting().fil.name }}</td>
<td class="status" colspan="4">
  @switch (opplasting().status()) {
    @case ('venter') {
      {{ 'Venter på opplasting...'|translate }}
    }
    @case ('lasteropp') {
      <span class="laster-opp">
        <mat-progress-spinner mode="determinate" [value]="opplasting().progresjon()" diameter="20"/>
        {{ 'Laster opp...'|translate }}
      </span>
    }
    @case ('avbrutt') {
      {{ 'Opplasting avbrutt'|translate }}
    }
  }
</td>
<td class="meny" colspan="2">
  @if (visAvbryt()) {
    <button mat-button color="primary" (click)="avbryt()" matTooltip="{{'Klikk for å avbryte denne opplastingen'|translate}}" data-testid="avbryt">
      <mat-icon>cancel</mat-icon>
      <span>{{ 'Avbryt opplasting'|translate }}</span>
    </button>
  }
</td>
